module.exports = __webpack_public_path__ + "static/media/plate4_icon7.9387eb8d.png";